import { API_BASE } from "@/lib/utils";

/** Persist event.cover (used by portfolio grid + hero fallback). */
export async function patchEventCover(eventId, coverUrl) {
  const id = String(eventId || "").trim();
  const cover = String(coverUrl || "").trim();
  if (!id || !cover) return false;
  const res = await fetch(`${API_BASE}/api/admin/events/${encodeURIComponent(id)}`, {
    method: "PUT",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ cover }),
  });
  return res.ok;
}
